import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ErrorBoundary } from '@/lib/errors/ErrorBoundary';
import { logger } from '@/lib/logger';
import { systemConfig } from '@/config/system.config';
import { useAuthStore } from '@/store/auth.store';
import { trySsoSilentLogin } from '@/services/auth/auth.service';

function App() {
  useEffect(() => {
    void (async () => {
      const { token } = useAuthStore.getState();
      if (token) {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug('[planning-auth]', 'App mount: skip trySsoSilentLogin — already have token');
        return;
      }
      if (!systemConfig.tenantId) {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug(
          '[planning-auth]',
          'App mount: skip trySsoSilentLogin — no build-time tenantId'
        );
        return;
      }
      // eslint-disable-next-line no-console -- login diagnostics
      console.debug('[planning-auth]', 'App mount: trySsoSilentLogin()');
      const data = await trySsoSilentLogin();
      if (data?.accessToken && data.user && data.tenantId) {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug('[planning-auth]', 'App mount: SSO silent login succeeded, hydrating store');
        useAuthStore.getState().login(data.accessToken, data.user, data.tenantId);
      }
    })();
  }, []);

  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        logger.error('Root error boundary caught error', error, {
          componentStack: errorInfo.componentStack,
        });
      }}
    >
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}

export default App;
